export default __webpack_public_path__ + "static/media/SIFA_FR_SEQ11.ef3a05e2.mp3";